import { render } from "./PiarTabContent.vue?vue&type=template&id=ec5f3bf4&ts=true"
import script from "./PiarTabContent.vue?vue&type=script&lang=ts"
export * from "./PiarTabContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__